import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import queryString from 'query-string'
import http from 'axios'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { formatDate, formatNumber } from 'core/lib'

import PayPal from './OnlinePay/PayPal'
import Stripe from './OnlinePay/Stripe'

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
	return new URLSearchParams(useLocation().search)
}

function OrderConfirm({ classes }) {
	const navigate = useNavigate()
	const params = useQuery().get('p')
	const dispatch = useDispatch()
	const [response, setResponse] = useState({
		isLoaded: false,
		error: false,
		errcode: 0,
		message: '',
		data: {},
	})

	useEffect(() => {
		const verify = () => {
			dispatch({ type: 'startLoad@ui' })
			const instance = axios.create()
			instance.get(`${window.__endpoint}/api/order/loadForPayment?p=${params}`)
				.then((response) => {
					dispatch({ type: 'stopLoad@ui' })
					setResponse({
						error: false,
						message: response.data.message,
						data: response.data.data,
						isLoaded: true,
					})
				})
				.catch(error => {
					dispatch({ type: 'stopLoad@ui' })
					setResponse({
						error: true,
						errcode: error.response ? error.response.data.errcode : '',
						message: error.response ? error.response.data.message : '',
						data: {},
						isLoaded: true,
					})
				})
		}

		verify()
	}, [])

	const saveTransactionPayPal = (paymentId) => {
		const orderToken = queryString.parse(atob(params)).t
		http.get(`${window.__endpoint}/api/order/paypalPayCheck?p=${paymentId}&o=${orderToken}`)
	}

	const saveTransactionStripe = (id) => {
		const orderToken = queryString.parse(atob(params)).t
		http.get(`${window.__endpoint}/api/order/stripePayCheck?s=${id}&o=${orderToken}`)
	}

	return (<div className={classes.page}>
		{response.isLoaded && <React.Fragment>
			<h2 className={classes.pageTitle}>{response.error && response.errcode == 1 ? 'Errore nella caricamento dell\'ordine' : 'Pagamento dell\'ordine'}</h2>
			<center>
				{response.error && response.errcode == 1 && <p>Si è verificato un problema nel caricamento del tuo ordine</p>}
				<div dangerouslySetInnerHTML={{
					__html: response.message
				}}></div>

				{!response.error && <div>
					<h3>Riepilogo ordine</h3>
					<p>Ordine n. {response.data.order_number} del {formatDate(response.data.order_date)}</p>
					<p>
						{`${response.data.name} ${response.data.surname}`}<br/>
						{response.data.email}<br/>
						Tel. {response.data.mobile}
					</p>
					{response.data.shipping_method_id == 6 && <p>L'importo totale da pagare ti verrà comunicato tramite mail</p>}
					{response.data.shipping_method_id != 6 && <p>Importo da pagare {formatNumber(response.data.total_to_pay)} €</p>}
				</div>}

				{response.data.payment_method && response.data.payment_method.payment_method_id == 3 && <PayPal
					totalFee={response.data.total_to_pay}
					clientID={response.data.payment_method.settings}
					onConfirm={saveTransactionPayPal}
				/>}

				{response.data.payment_method && response.data.payment_method.payment_method_id == 5 && <Stripe
					order={response.data}
					chiavePubblica={response.data.payment_method.settings}
					onConfirm={saveTransactionStripe}
				/>}
				<p>
					{response.error && <Button color="primary" variant="contained" onClick={() => navigate('/')}>Prosegui gli acquisti</Button>}
				</p>
			</center>
		</React.Fragment>}
	</div>)
}

export default withStyles(style)(OrderConfirm)
